export function mapBoardsToRows(boards = []) {
  return boards.map((board, index) => ({
    ...board,
    id: index,
  }));
}

export function filterBoardsBySearch(boards = [], searchText = "") {
  const normalizedSearch = searchText.toLowerCase();

  return boards.filter((board) =>
    board.board_name.toLowerCase().includes(normalizedSearch)
  );
}

export function filterBoardsByStatus(boards = [], filterBoard) {
  if (!filterBoard || filterBoard === "all") {
    return boards;
  }

  if (filterBoard === "active") {
    return boards.filter((board) => !board.is_archive);
  }

  return boards.filter((board) => board.is_archive);
}

export function getBoardRows(boards = [], searchText = "", filterBoard) {
  const mappedBoards = mapBoardsToRows(boards);
  const searchFilteredBoards = filterBoardsBySearch(mappedBoards, searchText);

  return filterBoardsByStatus(searchFilteredBoards, filterBoard);
}

export function sortBoardUsers(users = []) {
  return [...users].sort((leftUser, rightUser) =>
    leftUser.username.localeCompare(rightUser.username)
  );
}
